import React from "react";
import "./AboutUs.css";

import {
  FaChartLine,
  FaCheckCircle,
  FaFileContract,
  FaHandHoldingUsd,
  FaHeadset,
  FaInfinity,
  FaLeaf,
  FaLightbulb,
  FaMapMarkedAlt,
  FaRoad,
  FaShieldAlt,
  FaTools,
  FaUserCheck,
  FaUsers,
  FaWater,
} from "react-icons/fa";
import AboutBanner from "./AboutBanner";
import SisterConcerms from "./SisterConcerms";
import imgBilding from "../../assets/gallery/greenland.jpg";

const AboutUs = () => {
  return (
    <div className="about-container">
      <div className="about-us-section">
        <AboutBanner
          title="ABOUT ICONIC GREENLAND"
          description="Your trusted partner in secure land development and sustainable community building."
        />
        {/* 1. Who We Are */}
        <section className="md:py-20 py-10">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6">
                <span className="text-info fw-bold text-uppercase small tracking-wider">
                  Who We Are
                </span>
                <h2 className="display-5 fw-bold mt-2 mb-4">
                  Bangladesh's Trusted{" "}
                  <span style={{ color: "#BD06D3" }}>Land Developer</span>
                </h2>
                <p className="lead text-muted">
                  Iconic Greenland is one of Bangladesh's trusted land
                  development companies dedicated to providing legally verified
                  residential and commercial plots in strategic locations.
                </p>
                <p className="text-muted">
                  Our commitment is to create secure investments, modern
                  communities, and lasting value for every client. We bridge the
                  gap between dreams and reality by ensuring every square foot
                  we develop is backed by trust and excellence.
                </p>
              </div>
              <div className="col-lg-6">
                <div className="rounded-4 overflow-hidden h-50">
                  <img
                    src={imgBilding}
                    alt="Company"
                    className="w-100 h-50 object-fit-cover"
                    style={{ minHeight: "280px", maxHeight: "600px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* 2. What We Do */}
        <section className="">
          <div className="container md:py-20 py-10">
            <div className="text-center mb-5">
              <h2 className="fw-bold">What We Do</h2>
            </div>
            <div className="row g-4">
              {[
                {
                  title: "Residential Plots",
                  icon: <FaMapMarkedAlt />,
                  desc: "Planning and developing premium living spaces.",
                },
                {
                  title: "Commercial Plots",
                  icon: <FaChartLine />,
                  desc: "Strategic locations for thriving business hubs.",
                },
                {
                  title: "Investment Consultancy",
                  icon: <FaHandHoldingUsd />,
                  desc: "Expert advice on high-growth land investments.",
                },
                {
                  title: "Documentation Support",
                  icon: <FaFileContract />,
                  desc: "Hassle-free legal and registration processes.",
                },
                {
                  title: "Property Development",
                  icon: <FaTools />,
                  desc: "Constructing modern infrastructure and amenities.",
                },
                {
                  title: "Customer Service",
                  icon: <FaHeadset />,
                  desc: "Dedicated support for every step of your journey.",
                },
              ].map((item, i) => (
                <div className="col-md-4" key={i}>
                  <div className="card h-100 border-0 shadow-sm p-4 text-center hover-top transition">
                    <div className="fs-1 mb-3" style={{ color: "#BD06D3" }}>
                      {item.icon}
                    </div>
                    <h4 className="fw-bold">{item.title}</h4>
                    <p className="text-muted mb-0">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* 3. Our Expertise */}
        <section>
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="fw-bold">Our Expertise</h2>
            </div>
            <div className="row g-4 text-center">
              {[
                "Land Acquisition",
                "Project Planning",
                "Legal Verification",
                "Infrastructure Development",
              ].map((exp, i) => (
                <div className="col-lg-3 col-6" key={i}>
                  <div className="p-4 bg-white rounded-4 shadow-sm border-bottom border-4 border-success">
                    <FaCheckCircle className="text-success mb-3" size={30} />
                    <h5 className="fw-bold mb-0">{exp}</h5>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* 4. Development Process */}
        <section>
          <div className="container">
            <h2 className="text-center fw-bold mb-5">
              Our Development Process
            </h2>
            <div className="d-flex flex-wrap justify-content-center gap-3 timeline-wrapper">
              {[
                "Acquire Land",
                "Legal Verification",
                "Planning",
                "Development",
                "Booking",
                "Registration",
                "Handover",
              ].map((step, i) => (
                <div key={i} className="d-flex align-items-center">
                  <div className="bg-info text-white px-4 py-2 rounded-pill fw-bold shadow-sm">
                    {i + 1}. {step}
                  </div>
                  {i < 6 && (
                    <div className="d-none d-lg-block px-2 text-muted">→</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* "Modern architectural design and construction.", "Electricity and
        dedicated solar panel systems.", "Supply water and private deep
        tube-well water facilities.", " Modern elevators and advanced security
        systems.", "Exclusive community center and gym facilities.", "Rooftop
        barbecue zone and luxurious swimming pool.", "Spacious, open environment
        and secure parking.", "Shopping mall and dedicated children's play
        zone.", "Separate prayer rooms for men and women.", "24/7 monitoring via
        CCTV. Safe and well-planned emergency exit.", */}
        {/* 5. Why Invest With Us */}
        <section className="py-5">
          <div className="container">
            <div className="row align-items-center g-10">
              <div className="col-lg-6">
                <img
                  src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&q=80&w=800"
                  className="img-fluid rounded-4 shadow"
                  alt="Invest"
                />
              </div>
              <div className="col-lg-6">
                <h2 className="fw-bold mb-4">Why Invest With Us</h2>
                <ul className="list-unstyled">
                  {[
                    "Prime Strategic Locations",
                    "100% Verified Land Documentation",
                    "High ROI Appreciation",
                    "Flexible Installment Plans",
                    "Secure Ownership Transfer",
                    "Transparent Pricing",
                    "Excellent After-Sales Support",
                  ].map((item, i) => (
                    <li
                      key={i}
                      className="mb-3 d-flex align-items-center gap-3 fs-5"
                    >
                      <FaCheckCircle style={{ color: "#BD06D3" }} /> {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* 6. Infrastructure & Quality */}
        <section>
          <div className="container">
            <h2 className="text-center fw-bold mb-5">
              Infrastructure & Quality
            </h2>
            <div className="row g-4">
              {[
                {
                  icon: <FaRoad />,
                  title: "Wide Roads",
                  desc: "Spacious 40ft-60ft main roads.",
                },
                {
                  icon: <FaLightbulb />,
                  title: "Electricity",
                  desc: "Reliable power connections.",
                },
                {
                  icon: <FaWater />,
                  title: "Drainage",
                  desc: "Planned sewerage systems.",
                },
                {
                  icon: <FaLeaf />,
                  title: "Green Space",
                  desc: "Parks and recreational areas.",
                },
                {
                  icon: <FaRoad />,
                  title: "Street Lighting",
                  desc: "Solar & LED street lights.",
                },
                {
                  icon: <FaWater />,
                  title: "Water Supply",
                  desc: "Centralized water system.",
                },
              ].map((item, i) => (
                <div className="col-md-4 col-sm-6" key={i}>
                  <div className="p-4 border rounded-4 h-100 text-center">
                    <div className="text-info mb-3">{item.icon}</div>
                    <h5 className="fw-bold">{item.title}</h5>
                    <p className="text-muted small">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* 7. Legal Commitment */}
        <section className="py-2">
          <div className="container">
            <div
              className="card border-0 border-start border-5 shadow-sm p-5"
              style={{ borderColor: "#BD06D3 !important" }}
            >
              <div className="row align-items-center">
                <div className="col-md-4">
                  <h2 className="display-4 fw-bold text-dark">100%</h2>
                  <p className="fw-bold text-uppercase">
                    Legally Verified Projects
                  </p>
                </div>
                <div className="col-md-8 border-start ps-md-5">
                  <div className="row g-3">
                    {[
                      "Clear Ownership",
                      "Mutation Support",
                      "Registration Assistance",
                      "Transparent Documentation",
                    ].map((text, i) => (
                      <div className="col-6 fw-bold" key={i}>
                        <FaShieldAlt className="text-success me-2" /> {text}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* 8 & 9. Highlights & Statistics */}
        {/* <section className="py-5  text-white text-center">
          <div className="container">
            <div className="row g-4">
              {[
                { label: "Years Experience", val: "15+" },
                { label: "Happy Customers", val: "500+" },
                { label: "Total Plots", val: "1000+" },
                { label: "Live Projects", val: "20+" },
              ].map((stat, i) => (
                <div className="col-md-3 col-6" key={i}>
                  <h2 className="display-5 fw-bold" style={{ color: '#BD06D3' }}>{stat.val}</h2>
                  <p className="text-uppercase small mb-0">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section> */}
        {/* 10. Customer Commitment */}
        <section className="py-50">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6 order-2  order-lg-1">
                <img
                  src="https://i.pinimg.com/736x/46/ae/c2/46aec263aa5a15aa1061e58d4eace33b.jpg"
                  className="img-fluid rounded-4 shadow"
                  alt="Support"
                />
              </div>
              <div className="col-lg-6 order-1 order-lg-2">
                <h2 className="fw-bold mb-4">Our Customer Commitment</h2>
                <div className="d-flex flex-column gap-4">
                  {[
                    {
                      title: "Dedicated Support",
                      desc: "A team to guide you through every query.",
                    },
                    {
                      title: "Professional Guidance",
                      desc: "Expert advice on legal and financial aspects.",
                    },
                    {
                      title: "Transparent Communication",
                      desc: "No hidden costs, no false promises.",
                    },
                    {
                      title: "After-Sales Support",
                      desc: "We stay with you until the final handover.",
                    },
                  ].map((item, i) => (
                    <div className="d-flex gap-3" key={i}>
                      <div className="text-info mt-1">
                        <FaUserCheck size={24} />
                      </div>
                      <div>
                        <h5 className="fw-bold mb-1">{item.title}</h5>
                        <p className="text-muted">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* 11. Sustainability */}
        <section className="py-5">
          <div className="container">
            <h2 className="text-center fw-bold mb-5">
              Sustainability & Green Planning
            </h2>
            <div className="row g-4">
              {[
                "Green Planning",
                "Eco-Friendly Development",
                "Water Management",
                "Community Spaces",
              ].map((item, i) => (
                <div className="col-md-3" key={i}>
                  <div className="card border-0 shadow-sm p-4 text-center h-100">
                    <FaLeaf className="text-success mb-3 mx-auto" size={40} />
                    <h6 className="fw-bold mb-0">{item}</h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <style
          dangerouslySetInnerHTML={{
            __html: `
                .py-100 { padding: 100px 0; }
                .hover-top:hover { transform: translateY(-10px); transition: 0.3s; }
                .transition { transition: 0.3s; }
                .timeline-wrapper div { font-size: 0.9rem; }
                @media (max-width: 991px) {
                    .timeline-wrapper { flex-direction: column; align-items: flex-start !important; padding-left: 20px; }
                }
            `,
          }}
        />
        {/* Sister Concern */}
        <SisterConcerms></SisterConcerms>
      </div>
    </div>
  );
};

export default AboutUs;
